var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardView',{attrs:{"schema":_vm.noteInfo,"sourceData":_vm.data,"column":2}})}
var staticRenderFns = []

export { render, staticRenderFns }